export const retryPromises = async <T>(promises: (Promise<T>)[], maxRetries: number): Promise<(T | Error)[]> => {
  const promiseWithRetry = (p: () => Promise<T>, retries: number): Promise<T> => {
    return p().catch(err => {
      if (retries < maxRetries) {
        console.log(`Retrying promise: ${p.name}, attempt ${retries + 1} of ${maxRetries}`);
        return promiseWithRetry(p, retries + 1);
      } else {
        throw err;
      }
    });
  };
  return await Promise.all(promises.map(p => promiseWithRetry(() => p, 0)));
};
